// Helpers de formatação de endereço para uso em telas de revisão/checkout/
// minha-conta. Aceita o shape persistido pela API (Address model):
// { street, number, complement, district, city, state, country, zip, ... }

export function formatCep(zip) {
  if (!zip) return '';
  const digits = String(zip).replace(/\D/g, '');
  if (digits.length !== 8) return zip;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

// Formata como "Rua X, 123 (apto 4) - Bairro, Cidade/UF - CEP: 12345-678".
// Partes ausentes são puladas para não vazar separadores soltos.
export function formatAddress(a) {
  if (!a) return '';
  const streetLine = [
    a.street,
    a.number,
  ].filter(Boolean).join(', ');
  const withComplement = a.complement
    ? `${streetLine} (${a.complement})`
    : streetLine;
  const cityState = [a.city, a.state].filter(Boolean).join('/');
  const districtCity = [a.district, cityState].filter(Boolean).join(', ');
  const cep = a.zip ? `CEP: ${formatCep(a.zip)}` : '';
  return [withComplement, districtCity, cep].filter(Boolean).join(' - ');
}
